const trueValues = new Set(['1', 'true', 'yes', 'on'])

function readBooleanFlag(value, defaultValue = false) {
  if (value === undefined || value === null || value === '') {
    return defaultValue
  }
  return trueValues.has(String(value).trim().toLowerCase())
}

const featureConfig = Object.freeze({
  dinein: readBooleanFlag(process.env.VUE_APP_ENABLE_DINEIN, true)
})

const dineinRouteNames = new Set([
  'dinein',
  'dineinOrder',
  'dineinOrderLegacy',
  'dineinTable',
  'dineinTableArea',
  'dineinKitchenStation',
  'dineinPrinter',
  'dineinReport'
])

export function isDineinEnabled() {
  return featureConfig.dinein === true
}

export function isRouteFeatureEnabled(route) {
  if (!route || !route.name) {
    return true
  }
  if (dineinRouteNames.has(route.name)) {
    return isDineinEnabled()
  }
  return true
}

export default featureConfig



// WEBPACK FOOTER //
// ./src/config/features.js